export const JiraLogoNeutral = () => (
  <svg
    width="111"
    height="48"
    viewBox="0 0 111 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.971 3.5H17.894C17.894 8.006 21.547 11.658 26.052 11.658H29.381V14.871C29.381 19.377 33.034 23.029 37.539 23.029V5.068C37.539 4.202 36.837 3.5 35.971 3.5Z"
      fill="#758195"
    />
    <path
      d="M27.024 12.5049H8.94702C8.94702 17.0109 12.6 20.6629 17.105 20.6629H20.434V23.8759C20.434 28.3819 24.087 32.0339 28.592 32.0339V14.0729C28.592 13.2069 27.89 12.5049 27.024 12.5049Z"
      fill="url(#paint0_linear_2317_24553)"
    />
    <path
      d="M18.077 21.5098H0C0 26.0158 3.653 29.6688 8.158 29.6688H11.487V32.8818C11.487 37.3878 15.14 41.0398 19.645 41.0398V23.0788C19.645 22.2128 18.943 21.5108 18.077 21.5108V21.5098Z"
      fill="url(#paint1_linear_2317_24553)"
    />
    <path
      d="M56.641 8.38574H60.782V29.4097C60.782 34.9757 58.344 38.7947 52.639 38.7947C50.477 38.7947 48.821 38.4267 47.67 38.0127V34.0107C48.912 34.5167 50.431 34.7927 51.948 34.7927C55.445 34.7927 56.64 32.6767 56.64 29.6867V8.38574H56.641Z"
      fill="#44546F"
    />
    <path
      d="M68.324 6.7749C69.934 6.7749 71.084 7.7869 71.084 9.5359C71.084 11.2849 69.935 12.2959 68.324 12.2959C66.713 12.2959 65.563 11.2839 65.563 9.5359C65.563 7.7879 66.713 6.7749 68.324 6.7749ZM66.3 15.6079H70.257V38.6109H66.3V15.6079Z"
      fill="#44546F"
    />
    <path
      d="M80.1 38.6108H76.236V15.6078H80.1V19.6568C81.434 16.9418 83.735 15.0108 88.244 15.2858V19.1498C83.183 18.6438 80.1 20.1628 80.1 25.0388V38.6108Z"
      fill="#44546F"
    />
    <path
      d="M106.781 34.4709C105.309 37.5069 102.549 39.0719 99.007 39.0719C92.888 39.0719 89.806 33.8729 89.806 27.1099C89.806 20.6239 93.026 15.1489 99.467 15.1489C102.825 15.1489 105.402 16.6679 106.781 19.6579V15.6089H110.738V38.6119H106.781V34.4709ZM100.064 35.3909C103.607 35.3909 106.781 33.1369 106.781 28.0309V26.1899C106.781 21.0839 103.883 18.8299 100.524 18.8299C96.062 18.8299 93.761 21.7739 93.761 27.1099C93.761 32.6309 95.969 35.3909 100.064 35.3909Z"
      fill="#44546F"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2317_24553"
        x1="28.208"
        y1="12.5359"
        x2="20.519"
        y2="20.4659"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2317_24553"
        x1="19.772"
        y1="21.5938"
        x2="10.882"
        y2="30.2448"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
    </defs>
  </svg>
);
